"use client";
import { TextInput } from "djinn-components";
import React from "react";
import { Controller } from "react-hook-form";
import { ContentPageEditProps } from "..";
import Form from "../../Form";
import FormFieldErrors from "../../Form/FormFieldErrors";
import { toast } from "react-toastify";
import { useSiteState } from "../../../utils/useSiteState";

const PageDetailsTab: React.FC<ContentPageEditProps> = ({ page }) => {
  const { site } = useSiteState();

  const getDefaults = () => {
    const { title, description } = page;

    return {
      title,
      description,
    };
  };

  const onSubmit = async (responseData: any) => {
    // await fetchUser();
    toast("Page details updated", { type: "success" });
  };

  return (
    <Form
      getDefaults={getDefaults}
      onCompleted={onSubmit}
      buttonTitle="Update Details"
      endpoint={`sites/${site!.id}/pages/${page.id}`}
      method="put"
      className="w-full text-white"
      render={({ errors, control, reset, watch }) => (
        <>
          <div className="mb-4 mt-6">
            <label className="mb-2 block ml-4 text-sm font-medium">
              Page Title
            </label>
            <Controller
              name="title"
              control={control}
              defaultValue=""
              rules={{
                required: true,
              }}
              render={({ field: { onChange, value } }: any): JSX.Element => (
                <TextInput
                  value={value}
                  onChange={onChange}
                  invalid={!!errors.title}
                  placeholder="Page Name"
                />
              )}
            />

            <FormFieldErrors
              errors={errors}
              field="title"
              requiredMessage="Page name is required"
            />
          </div>

          <div className="mb-6 mt-6">
            <label className="mb-2 block ml-4 text-sm font-medium">
              Page Description
            </label>
            <Controller
              name="description"
              control={control}
              defaultValue=""
              rules={{
                required: true,
              }}
              render={({ field: { onChange, value } }: any): JSX.Element => (
                <TextInput
                  value={value}
                  onChange={onChange}
                  invalid={!!errors.description}
                  placeholder="Page Description"
                />
              )}
            />

            <FormFieldErrors
              errors={errors}
              field="description"
              requiredMessage="Page description is required"
            />
          </div>
        </>
      )}
    />
  );
};

export default PageDetailsTab;
